export default "__VITE_ASSET__DKFjVXxh__"